import React from "react";
import { Droppable, Draggable } from "react-beautiful-dnd";

const RightPanel = ({
  nombre,
  equipoSearchTerm,
  setEquipoSearchTerm,
  filteredAddedGroups,
  filteredAddedProducts,
  checkedItems,
  handleCheckItem,
  handleCheckAllGroup,
  handleDeleteSelectedInGroup,
  formatNumber,
  editMode,
  handleProductQuantityChange,
  handleCostChangeInGroup,
  handleUnassignedProductQuantityChange,
  handleCostChangeInUnassigned,
  handleDeleteSelectedInUnassigned,
  handleDrop,
  unassignedTitle,
  setUnassignedTitle,
  handleCheckAllUnassigned,
  // Nueva prop para actualizar el título de grupo
  handleGroupTitleChange,
}) => {
  return (
    <div className="right-column">
      <section
        className="equipo-container"
        onDragOver={(e) => e.preventDefault()}
        onDrop={handleDrop}
        style={!editMode ? { pointerEvents: "none", opacity: 0.9 } : {}}
      >
        <h1 className="calculador-title">{nombre || ""}</h1>

        {/* Buscador y filtros de la derecha */}
        <div style={{ marginBottom: "10px" }}>
          <div className="header-actions-proyectos">
            <button className="action-button-proyectos">
              <i className="bi bi-funnel-fill"></i> Todos{" "}
              <i
                className="bi bi-chevron-down"
                style={{ fontSize: "12px" }}
              ></i>
            </button>
            <div className="buscador-pedidos">
              <i className="bi bi-search"></i>
              <input
                type="text"
                className="buscador-input"
                placeholder="Buscar..."
                value={equipoSearchTerm}
                onChange={(e) => setEquipoSearchTerm(e.target.value)}
              />
            </div>
          </div>
        </div>

        {/* Contenedor principal donde listamos grupos y productos */}
        <div className="equipo-table-wrapper">
          {filteredAddedGroups.length === 0 &&
          filteredAddedProducts.length === 0 ? (
            equipoSearchTerm.trim() ? (
              <div className="no-resultados">
                <div
                  className="mensaje-sin-resultados"
                  style={{ marginTop: "30px" }}
                >
                  <p style={{ fontSize: "14px" }}>
                    No hay resultados disponibles
                  </p>
                </div>
                <div className="imagen-sin-resultados">
                  <img
                    src="/img/noSearch.svg"
                    alt="Sin resultados"
                    className="sin-resultados-imagen"
                  />
                </div>
              </div>
            ) : (
              <div>
                <p
                  style={{ margin: "20px", color: "#666", textAlign: "center" }}
                >
                  Aún no hay ningún producto o grupo seleccionado
                </p>
                <img
                  src="/img/no-gastos.svg"
                  alt="No se encontraron productos"
                  style={{
                    display: "block",
                    paddingTop: "20px",
                    margin: "0 auto",
                    width: "200px",
                    height: "200px",
                  }}
                />
              </div>
            )
          ) : (
            <>
              {/* Renderizado de grupos */}
              {filteredAddedGroups.length > 0 && (
                <Droppable droppableId="groupsDroppable" type="GROUP">
                  {(providedGroups) => (
                    <div
                      ref={providedGroups.innerRef}
                      {...providedGroups.droppableProps}
                    >
                      {filteredAddedGroups.map((grp, grpIndex) => {
                        const total = grp.products.reduce(
                          (acc, p) => acc + p.subtotal,
                          0
                        );
                        return (
                          <Draggable
                            key={`group-${grpIndex}`}
                            draggableId={`group-${grpIndex}`}
                            index={grpIndex}
                          >
                            {(providedGrp) => (
                              <div
                                ref={providedGrp.innerRef}
                                {...providedGrp.draggableProps}
                                style={{
                                  marginBottom: "20px",
                                  ...providedGrp.draggableProps.style,
                                }}
                              >
                                <div
                                  className="grupo"
                                  {...providedGrp.dragHandleProps}
                                  style={{ position: "relative" }}
                                >
                                  <i className="bi bi-grid-3x3-gap"></i>
                                  {editMode ? (
                                    <input
                                      type="text"
                                      value={grp.groupName}
                                      onChange={(e) =>
                                        handleGroupTitleChange(
                                          grpIndex,
                                          e.target.value
                                        )
                                      }
                                      onMouseDown={(e) => e.stopPropagation()}
                                      style={{ marginLeft: "8px" }}
                                    />
                                  ) : (
                                    <span
                                      className="grupo-title"
                                      style={{ marginLeft: "8px" }}
                                    >
                                      {grp.groupName}
                                    </span>
                                  )}
                                  <span className="grupo-count">
                                    {grp.products.length}
                                  </span>
                                  {grp.products.some((prod, idx) =>
                                    checkedItems.includes(
                                      `group-${grp.groupName}-${prod.id}-${idx}`
                                    )
                                  ) && (
                                    <i
                                      className="bi bi-trash"
                                      onClick={() =>
                                        handleDeleteSelectedInGroup(
                                          grp.groupName
                                        )
                                      }
                                      style={{
                                        position: "absolute",
                                        right: 0,
                                        top: "50%",
                                        transform: "translateY(-50%)",
                                        cursor: "pointer",
                                        color: "red",
                                        fontSize: "1.2rem",
                                      }}
                                    />
                                  )}
                                </div>
                                <Droppable
                                  droppableId={`group-${grp.groupName}`}
                                  type="PRODUCT"
                                >
                                  {(providedProd) => (
                                    <div
                                      ref={providedProd.innerRef}
                                      {...providedProd.droppableProps}
                                      className="equipo-table"
                                      id={`drop-group-${grp.groupName}`}
                                    >
                                      <table>
                                        <thead>
                                          <tr>
                                            <th>
                                              <input
                                                type="checkbox"
                                                className="checkbox-select-all check"
                                                onChange={() =>
                                                  handleCheckAllGroup(grp)
                                                }
                                                checked={
                                                  grp.products.length > 0 &&
                                                  grp.products.every(
                                                    (prod, idx) =>
                                                      checkedItems.includes(
                                                        `group-${grp.groupName}-${prod.id}-${idx}`
                                                      )
                                                  )
                                                }
                                              />
                                            </th>
                                            <th>ARTÍCULO</th>
                                            <th>PRECIO</th>
                                            <th>CTD</th>
                                            <th>SUBTOTAL</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {grp.products.map((prod, index) => {
                                            const rowId = `group-${grp.groupName}-${prod.id}-${index}`;
                                            return (
                                              <Draggable
                                                key={rowId}
                                                draggableId={rowId}
                                                index={index}
                                              >
                                                {(providedItem) => (
                                                  <tr
                                                    ref={providedItem.innerRef}
                                                    {...providedItem.draggableProps}
                                                    {...providedItem.dragHandleProps}
                                                  >
                                                    <td>
                                                      <input
                                                        type="checkbox"
                                                        className="checkbox-select-all check"
                                                        checked={checkedItems.includes(
                                                          rowId
                                                        )}
                                                        onChange={() =>
                                                          handleCheckItem(rowId)
                                                        }
                                                      />
                                                    </td>
                                                    <td
                                                      style={{ width: "60%" }}
                                                    >
                                                      {prod.nombre}
                                                    </td>
                                                    <td>
                                                      {editMode ? (
                                                        <input
                                                          type="text"
                                                          value={formatNumber(
                                                            prod.costo
                                                          )}
                                                          onChange={(e) =>
                                                            handleCostChangeInGroup(
                                                              grp.groupName,
                                                              prod.id,
                                                              e.target.value
                                                            )
                                                          }
                                                          style={{
                                                            width: "100px",
                                                          }}
                                                        />
                                                      ) : (
                                                        <>
                                                          MXN{" "}
                                                          {formatNumber(
                                                            prod.costo
                                                          )}
                                                        </>
                                                      )}
                                                    </td>
                                                    <td
                                                      style={{
                                                        textAlign: "center",
                                                      }}
                                                    >
                                                      {editMode ? (
                                                        <input
                                                          type="number"
                                                          style={{
                                                            width: "50px",
                                                            textAlign: "center",
                                                          }}
                                                          value={prod.quantity}
                                                          onChange={(e) =>
                                                            handleProductQuantityChange(
                                                              grp.groupName,
                                                              prod.id,
                                                              e.target.value
                                                            )
                                                          }
                                                        />
                                                      ) : (
                                                        prod.quantity
                                                      )}
                                                    </td>
                                                    <td>
                                                      MXN{" "}
                                                      {formatNumber(
                                                        prod.subtotal
                                                      )}
                                                    </td>
                                                  </tr>
                                                )}
                                              </Draggable>
                                            );
                                          })}
                                        </tbody>
                                      </table>
                                      {providedProd.placeholder}
                                    </div>
                                  )}
                                </Droppable>
                                <div className="subtotal">
                                  Subtotal:{" "}
                                  <strong>MXN {formatNumber(total)}</strong>
                                </div>
                              </div>
                            )}
                          </Draggable>
                        );
                      })}
                      {providedGroups.placeholder}
                    </div>
                  )}
                </Droppable>
              )}

              {filteredAddedProducts.length > 0 && (
                <Droppable droppableId="unassignedDroppable" type="PRODUCT">
                  {(providedUnassigned) => (
                    <div
                      ref={providedUnassigned.innerRef}
                      {...providedUnassigned.droppableProps}
                      id="drop-unassigned"
                    >
                      <div
                        className="grupo"
                        style={{ marginTop: "20px", position: "relative" }}
                      >
                        <i className="bi bi-grid-3x3-gap"></i>
                        {editMode ? (
                          <input
                            type="text"
                            value={unassignedTitle}
                            onChange={(e) => setUnassignedTitle(e.target.value)}
                            className="grupo-title-input"
                          />
                        ) : (
                          <span className="grupo-title">{unassignedTitle}</span>
                        )}
                        <span className="grupo-count">
                          {filteredAddedProducts.length}
                        </span>
                        {filteredAddedProducts.some((prod, idx) =>
                          checkedItems.includes(`unassigned-${prod.id}-${idx}`)
                        ) && (
                          <i
                            className="bi bi-trash"
                            onClick={handleDeleteSelectedInUnassigned}
                            style={{
                              position: "absolute",
                              right: 0,
                              top: "50%",
                              transform: "translateY(-50%)",
                              cursor: "pointer",
                              color: "red",
                              fontSize: "1.2rem",
                            }}
                          />
                        )}
                      </div>
                      <div className="equipo-table">
                        <table>
                          <thead>
                            <tr>
                              <th>
                                <input
                                  type="checkbox"
                                  className="checkbox-select-all check"
                                  onChange={() =>
                                    handleCheckAllUnassigned(
                                      filteredAddedProducts
                                    )
                                  }
                                  checked={
                                    filteredAddedProducts.length > 0 &&
                                    filteredAddedProducts.every((prod, idx) =>
                                      checkedItems.includes(
                                        `unassigned-${prod.id}-${idx}`
                                      )
                                    )
                                  }
                                />
                              </th>
                              <th>ARTÍCULO</th>
                              <th>PRECIO</th>
                              <th>CTD</th>
                              <th>SUBTOTAL</th>
                            </tr>
                          </thead>
                          <tbody>
                            {filteredAddedProducts.map((prod, index) => {
                              const rowId = `unassigned-${prod.id}-${index}`;
                              return (
                                <Draggable
                                  key={rowId}
                                  draggableId={rowId}
                                  index={index}
                                >
                                  {(providedItem) => (
                                    <tr
                                      ref={providedItem.innerRef}
                                      {...providedItem.draggableProps}
                                      {...providedItem.dragHandleProps}
                                    >
                                      <td>
                                        <input
                                          type="checkbox"
                                          className="checkbox-select-all check"
                                          checked={checkedItems.includes(rowId)}
                                          onChange={() =>
                                            handleCheckItem(rowId)
                                          }
                                        />
                                      </td>
                                      <td style={{ width: "60%" }}>
                                        {prod.nombre}
                                      </td>
                                      <td>
                                        {editMode ? (
                                          <input
                                            type="text"
                                            value={formatNumber(prod.costo)}
                                            onChange={(e) =>
                                              handleCostChangeInUnassigned(
                                                prod.id,
                                                index,
                                                e.target.value
                                              )
                                            }
                                            style={{ width: "100px" }}
                                          />
                                        ) : (
                                          <>MXN {formatNumber(prod.costo)}</>
                                        )}
                                      </td>
                                      <td style={{ textAlign: "center" }}>
                                        {editMode ? (
                                          <input
                                            type="number"
                                            style={{
                                              width: "50px",
                                              textAlign: "center",
                                            }}
                                            value={prod.quantity}
                                            onChange={(e) =>
                                              handleUnassignedProductQuantityChange(
                                                prod.id,
                                                index,
                                                e.target.value
                                              )
                                            }
                                          />
                                        ) : (
                                          prod.quantity
                                        )}
                                      </td>
                                      <td>MXN {formatNumber(prod.subtotal)}</td>
                                    </tr>
                                  )}
                                </Draggable>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                      {providedUnassigned.placeholder}
                    </div>
                  )}
                </Droppable>
              )}

              {(filteredAddedGroups.length > 0 ||
                filteredAddedProducts.length > 0) && (
                <div className="total-summary">
                  Total:{" "}
                  <strong>
                    MXN{" "}
                    {formatNumber(
                      filteredAddedGroups.reduce(
                        (acc, grp) =>
                          acc +
                          grp.products.reduce(
                            (sum, prod) => sum + prod.subtotal,
                            0
                          ),
                        0
                      ) +
                        filteredAddedProducts.reduce(
                          (acc, prod) => acc + prod.subtotal,
                          0
                        )
                    )}
                  </strong>
                </div>
              )}

              <Droppable droppableId="newTableDroppable" type="PRODUCT">
                {(provided, snapshot) => (
                  <div
                    id="newTableDroppable"
                    ref={provided.innerRef}
                    {...provided.droppableProps}
                    style={{
                      border: "2px dashed #ccc",
                      padding: "20px",
                      marginTop: "20px",
                      textAlign: "center",
                      minHeight: "60px",
                      opacity: snapshot.isDraggingOver ? 1 : 0,
                      transition: "opacity 0.3s ease",
                    }}
                  >
                    {snapshot.isDraggingOver && (
                      <p style={{ margin: 0 }}>
                        Arrastra aquí para crear otro <strong>Grupo</strong>
                      </p>
                    )}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </>
          )}
        </div>
      </section>
    </div>
  );
};

export default RightPanel;
